var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { List } from 'semantic-ui-react';
import styled from 'styled-components';
import Theme from '../theme.config';
export var Styled = styled(List)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  margin-bottom: 10px;\n"], ["\n  background: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  margin-bottom: 10px;\n"])), Theme.color.white);
var templateObject_1;
//# sourceMappingURL=style.js.map